var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 58,
    viewBox: "0 0 68 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7372 31.5947C20.6088 31.5947 5.10372 10.5825 0 0C16.6585 20.2695 32.1484 22.0652 39.9621 20.4526C59.0775 16.5077 65.6338 22.1316 67.216 25.7947C55.5795 23.2305 37.2061 37.7 24.3447 58C26.029 50.8263 34.1949 37.5474 38.7372 31.5947Z",
    fill: "#325FEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eb000f2a3cae011b271eac13c5fa6387.svg";
export { ForwardRef as ReactComponent };